import { TransformControls as TTransformControls } from 'three/examples/jsm/controls/TransformControls.js'
import type { Camera } from 'three'
import type SceneControl from '../scene/scene'

export class TransformControls extends TTransformControls {
  private sceneControl?: SceneControl

  constructor(object: Camera, domElement?: HTMLElement, sceneControl?: SceneControl) {
    super(object, domElement)
    this.sceneControl = sceneControl
  }

  public dispose() {
    super.dispose()

    if (this.sceneControl) {
      const index = this.sceneControl.context.transformControls.findIndex((item: TransformControls) => item === this)

      if (index > -1)
        this.sceneControl.context.transformControls.splice(index, 1)
    }
  }
}

const create = (camera: Camera, domElement: HTMLElement, size: number, sceneControl?: SceneControl) => {
  const transformControl = new TransformControls(camera, domElement, sceneControl)
  transformControl.size = size

  transformControl.addEventListener('dragging-changed', (event) => {
    const controls = sceneControl?.context.orbitControls
    if (controls)
      controls.enabled = !event.value
  })

  if (sceneControl) {
    sceneControl.context.setTransformControls(transformControl)
    sceneControl.context.scene!.add(transformControl.getHelper())
  }

  return transformControl
}

/**
 * create TransformControls
 * @returns
 */
export const createTransformControls = (camera: Camera, domElement: HTMLElement, size = 0.5, sceneControl?: SceneControl) => {
  return create(camera, domElement, size, sceneControl)
}
